import { LanguageCode } from '@kouto/types';

const chineseLocaleMap: Record<string, LanguageCode> = {
  'zh-CN': LanguageCode.ZH_HANS,
  'zh-SG': LanguageCode.ZH_HANS,
  'zh-TW': LanguageCode.ZH_HANT,
  'zh-HK': LanguageCode.ZH_HANT,
  'zh-MO': LanguageCode.ZH_HANT,
};

const checkForSupportedLanguageCode = (
  languageCode: string,
): LanguageCode | undefined => {
  if (chineseLocaleMap[languageCode]) {
    return chineseLocaleMap[languageCode];
  }
  return Object.values(LanguageCode).find(
    (code) => code === languageCode || code.startsWith(`${languageCode}`),
  );
};

export default checkForSupportedLanguageCode;
